import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ConnectedRouter } from 'connected-react-router';
import MainThemeProvider from '../theme/mainThemeProvider';
import SovosProvider from 's1-ui/sovos-provider';
import { Provider } from 'react-redux';
import App from './app/AppConnector';
import { createMuiTheme } from '@material-ui/core/styles';
import { purpleDecorations } from '../theme/mainColors';
import '../theme/mainStyles.css';

const theme = createMuiTheme({
  palette: {
    secondary: {
      main: purpleDecorations
    }
  },
  typography: {
    useNextVariants: true
  },
  overrides: {
    MuiTooltip: {
      tooltip: {
        fontSize: 12
      }
    },
    MuiMenuItem: {
      root: {
        fontSize: 13
      }
    }
  }
});

class Root extends Component {
  render() {
    const { store, history } = this.props;
    return (
      <SovosProvider theme={ theme }>
        <MainThemeProvider>
          <Provider store={ store }>
            <ConnectedRouter history={ history }>
              <App />
            </ConnectedRouter>
          </Provider>
        </MainThemeProvider>
      </SovosProvider>
    );
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default Root;



// WEBPACK FOOTER //
// ./src/components/Root.js